"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkAuthorities = exports.checkRole = void 0;
function checkRole(currentRole, requiredRole) {
    if (typeof requiredRole !== "object") {
        return currentRole === requiredRole;
    }
    else {
        return requiredRole.includes(currentRole);
    }
}
exports.checkRole = checkRole;
function checkAuthorities(currentAuthorities, requiredAuthorities) {
    return requiredAuthorities.every(authority => currentAuthorities.includes(authority));
}
exports.checkAuthorities = checkAuthorities;
//# sourceMappingURL=SecurityHelpers.js.map